import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Box, Flex, Button } from '@chatterbug/aaron'

import AchievementWidgetBody from 'src/pages/Achievements/subcomponents/AchievementWidget/subcomponents/AchievementWidgetBody/AchievementWidgetBody'
import routes from 'src/lib/rails-routes/rails-routes'
import Pressable from 'src/ui/Pressable/Pressable'
import { t } from 'src/lib/i18n-react'
import { usePageParams } from 'src/utils/params'

import HorizontalDivider from './subcomponents/HorizontalDivider/HorizontalDivider'

const AchievementsLiveLessonsList = ({ liveLessonsData }) => {
  const { l2Code } = usePageParams()
  return (
    <Box>
      <Box as="h5" variant="text.h5" mb="1x">
        {t('Live Lessons by most recent')}
      </Box>

      <Grid
        boxShadow="overlay"
        borderRadius="1x"
        minWidth={250}
        p={{ _: '2x', tablet: '29px' }}
        pl={{ _: null, tablet: 42 }} // figma
        gridTemplateColumns="repeat(1, 1fr)"
        gridGap="1x"
      >
        {liveLessonsData.length > 0 ? (
          liveLessonsData.map((lesson, index) => {
            const liveLessonInfo = {
              tutorAvatarUrl: lesson?.tutor?.avatarUrl,
              tutorLogin: lesson.tutor?.login,
              tutorName: lesson.tutor?.name,
              liveLessonReplayUrl: lesson?.chatSessionArchiveUrl,
              averageStudentRating: lesson?.averageStudentRating,
              ratingAgainForTutor: lesson?.ratingAgainForTutor,
              isFavorite: lesson?.tutor?.tutor?.isFavorite,
              appointmentId: lesson?.chatSessionId,
            }

            const activityInfo = {
              lessonThumbnail: lesson?.exercises?.nodes[0]?.imageUrl,
              liveLessonNumber: lesson?.liveLessonNumber,
              unitName: lesson?.unit?.name,
              date: `${lesson.startTimeAgo}, ${lesson.duration} min`,
              cefrLevel: lesson?.unit?.cefrLevel,
            }

            return (
              <Pressable
                key={index}
                linkUrl={routes.chat_show(l2Code, lesson?.chatSessionId)}
              >
                {index > 0 && <HorizontalDivider />}
                <AchievementWidgetBody
                  liveLessonInfo={liveLessonInfo}
                  activityInfo={activityInfo}
                  widgetType="liveLesson"
                  showPlaceholder={false}
                  isList
                />
                {!liveLessonInfo.ratingAgainForTutor && (
                  <Flex
                    display={{ _: 'flex', tablet: 'none' }}
                    mt="3x"
                    color="blue42"
                  >
                    <Box width="100%" alignSelf="flex-end">
                      <Button
                        href={routes.chat_complete(lesson?.chatSessionId)}
                        width="100%"
                        type="success"
                        fill="outline"
                        css={{
                          textDecoration: 'none',
                          // blue42
                          color: '#006FD6',
                        }}
                      >
                        {t('rate tutor')}
                      </Button>
                    </Box>
                  </Flex>
                )}
              </Pressable>
            )
          })
        ) : (
          <AchievementWidgetBody
            widgetType="liveLesson"
            showPlaceholder={true}
          />
        )}
      </Grid>
    </Box>
  )
}

AchievementsLiveLessonsList.propTypes = {
  liveLessonsData: PropTypes.object,
}

export default AchievementsLiveLessonsList
